import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./lib/auth";
import { I18nProvider } from "./lib/i18n"; // [#13]
import { ErrorBoundary } from "./components/ErrorBoundary";
import { hardenGlobals } from "./lib/harden";
import { migrateLegacyHashUrl } from "./lib/router-safe";
import { initNative } from "./lib/native";
import "./index.css";

// Restore pristine browser APIs before React mounts, so extensions that patch
// core DOM methods (e.g. ClickUp) can't crash the router at render time.
hardenGlobals();
// Old shared links used #/path — rewrite them to clean URLs before React mounts.
migrateLegacyHashUrl();

function mountApp() {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <ErrorBoundary>
        <I18nProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </I18nProvider>
      </ErrorBoundary>
    </React.StrictMode>,
  );
}

// Increment 45a: restore native auth state before AuthProvider performs its
// initial /me request. Native plugin failures remain best-effort so a failed
// optional integration cannot prevent the app from mounting.
void initNative()
  .catch(() => {})
  .then(mountApp);
